export default "/images/vendor/flag-icon-css/flags/4x3/my.svg?1f599a0e4a95880eabf14865f62393fd";